import React, { ReactElement } from 'react';
import { List } from 'react-admin';
import { Box } from '@mui/material';
import { ShsTitle } from 'src/components/common';
import { ShsReturnButton } from '../common';
import { ToolbarActions } from './components/ToolbarActions';
import { EducationCenterType } from '../Employees/types';

interface ChildrenReportProps {
    onReturn: () => void;
    filters: ReactElement | ReactElement[];
    filterDefaultValues?: any;
}

export const ChildrenReport: React.FC<ChildrenReportProps> = ({ onReturn, filters, filterDefaultValues }) => {
    const buttonLabel = 'Назад до звітів';
    const singleCenterId = filterDefaultValues?.educationCenterId;

    return (
        <>
            <Box display="flex" justifyContent="flex-start" mb={2}>
                <ShsReturnButton onClick={onReturn} label={buttonLabel} />
            </Box>
            <ShsTitle title="Звіти по дітях" />
            <List<EducationCenterType>
                resource="reports"
                exporter={false}
                empty={false}
                actions={<ToolbarActions pageUrl={'children'} singleCenterId={singleCenterId} />}
                filters={filters}
                pagination={false}>
                <></>
            </List>
        </>
    );
};
